const types = {
    SET_PHYSICIAN_DETAILS_LOADING: 'SET_PHYSICIAN_DETAILS_LOADING',
    SET_PHYSICIAN_DETAILS: 'SET_PHYSICIAN_DETAILS',
    SET_PHYSICIAN_BOOKMARKED_CASES: 'SET_PHYSICIAN_BOOKMARKED_CASES',
};

export default types;